module.exports = __webpack_public_path__ + "static/img/case6.db284a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/case6.png
// module id = //26
// module chunks = 0